import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import AudioPage from "./AudioPage.js";
import YouTubePage from "./YoutubePage.js";
import VideoPage from "./VideoPage.js";
import PreviewPage from "./PreviewPage.js";
import PptPage from "./PptPage.js";
import PdfPage from "./PdfPage.js";
import WordPage from "./WordPage.js";
import AddTextPage from "./AddTextPage.js";
import LoginPage from "./LoginPage.js";
import Navbar from "./Navbar";
import TermsPage from "./TermsPage";
import PrivacyPolicyPage from "./PrivacyPolicyPage";
import SubscriptionPolicyPage from "./SubscriptionPolicyPage";
import RefundPolicyPage from "./RefundPolicyPage";
import Footer from "./Footer";
import ProtectedRoute from "./components/ProtectedRoute";
import FeedbackPage from "./FeedbackPage";
import AdminPage from "./AdminPage";

import ScrollToTop from "./components/ScrollToTop";

// ... existing imports

function MainLayout() {
  const { currentUser } = useAuth();
  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>

      <Navbar />
      <ScrollToTop /> {/* Add ScrollToTop here inside the Layout */}
      <Routes>
        {/* Public Routes */}
        <Route path="/login" element={!currentUser ? <LoginPage /> : <Navigate to="/" />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="/subscription-policy" element={<SubscriptionPolicyPage />} />
        <Route path="/refund-policy" element={<RefundPolicyPage />} />
        <Route path="/feedback" element={<FeedbackPage />} />
        <Route path="/admin@nottsify-unistrix" element={<AdminPage />} />

        {/* Protected Routes */}
        <Route path="/" element={<ProtectedRoute><AudioPage /></ProtectedRoute>} />
        <Route path="/youtube" element={<ProtectedRoute><YouTubePage /></ProtectedRoute>} />
        <Route path="/video" element={<ProtectedRoute><VideoPage /></ProtectedRoute>} />
        <Route path="/preview" element={<ProtectedRoute><PreviewPage /></ProtectedRoute>} />
        <Route path="/pptpage" element={<ProtectedRoute><PptPage /></ProtectedRoute>} />
        <Route path="/pdf" element={<ProtectedRoute><PdfPage /></ProtectedRoute>} />
        <Route path="/word" element={<ProtectedRoute><WordPage /></ProtectedRoute>} />
        <Route path="/addtext" element={<ProtectedRoute><AddTextPage /></ProtectedRoute>} />
      </Routes>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <Router>
        <MainLayout />
      </Router>
    </AuthProvider>
  );
}